module.exports = __webpack_public_path__ + "img/ico-calendar.4f56a483.svg";